import { createContext } from 'react';

import type { TFleetCapabilities, TUserPermission } from '@/contexts/user-authorizations/UserPermissions';
import type { IFleetAccount } from '@/service/vpc/types/IFleetAccount';
import type { IUnit } from '@/service/vpc/types/IUnit';
import type { IRoleType } from '@/service/vpc/types/IUserAuthorizations';

export const FLEET_STORAGE_KEY = 'vpc_selected_fleet_account';

interface FleetAccountContextType {
  isLoading: boolean;
  isDigitalAccount: boolean;
  fleetAccounts: IFleetAccount[] | undefined;
  fleetAccountId: string | null;
  selectedFleetAccount: IFleetAccount | null;
  fleetVerifiedUnits: IUnit[];
  fleetAccountUnits: IUnit[];
  isMaximumClaimedReached: boolean;
  isMarineAccount: boolean;
  isIndustrialAccount: boolean;
  userHasPermission: (permission: TUserPermission) => boolean;
  userHasRole: (role: IRoleType[], fleetAccountId: string) => boolean;
  userHasCapability: (capability: TFleetCapabilities, unitId: number) => boolean;
  setFleetAccountId: (id: string | null) => void;
  clearFleetAccountId: () => void;
}

export const FleetAccountContext = createContext<FleetAccountContextType | undefined>(undefined);
